import { ApiService } from '../../common'
export class AppPricehelperApi extends ApiService {}
